<template>
  <section>
    <section class="my-5">
      <v-row>
        <v-col
          md="12"
          v-for="(data, index) in addresses"
          :key="index + 'address'"
        >
          <div class="shadowBox">
            <strong class="text-capitalize">
              {{ data.addressType.replace("Address", " Address") }}
              <v-icon @click="editAddress(data._id)">
                mdi-square-edit-outline</v-icon
              ></strong
            >

            <p class="text-capitalize">
              {{ data.fullname }}
            </p>
            <p>
              <span class="text-capitalize">{{ data.address }}</span>
              <span class="text-capitalize" v-if="data.ringRoad"
                >, {{ data.ringRoad }}</span
              >
              <span class="text-capitalize" v-if="data.valley"
                >, {{ data.valley }}</span
              >
              <span class="text-capitalize" v-if="data.province"
                >, {{ data.province }}</span
              >
              <span>, Nepal</span>
            </p>
            <p>+977 {{ data.phone1 }}</p>
            <p class="pb-3">
              {{ data.email }}
            </p>
          </div>
        </v-col>
      </v-row>
    </section>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Address",

  data: () => ({
    limit: 10,
    page: 1,
    addresses: undefined,
    loading: true,
    loadingSingle: false,
    selected: undefined,
  }),
  methods: {
    ...mapActions(["getAddresses", "postAddress"]),
    async defaultAction(id, index) {
      this.loadingSingle = true;
      this.selected = index;
      await this.postAddress({ _id: id, default: true });
      await this.getAddresses({ limit: this.limit, page: this.page });
      this.addresses = this.allAddresses.results;
      this.loadingSingle = false;
    },
    editAddress(data) {
      this.$router.push(`/addAddress/${data}`);
    },
  },
  computed: {
    ...mapGetters(["allAddresses"]),
  },
  async created() {
    await this.getAddresses({
      limit: this.limit,
      page: this.page,
      default: true,
    });
    this.addresses = this.allAddresses.results;
    this.loading = false;
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global.scss";
.navBack {
  background: #f4f4f4;
  padding: 10px 0;
}
.navList {
  padding-left: 0;
  list-style: none;
  display: flex;
  font-size: 14px;
  li {
    .v-icon {
      font-size: 18px;
      margin-left: 5px;
    }
    // margin-right: 15px;
  }
}
p {
  font-size: 14px;
}
.v-btn {
  min-height: 5 0px;
  width: 200px;
  color: #0878d4 !important;
  background: #fff !important;
  border: 1px solid #0878d4;
  box-shadow: none !important;
}
strong {
  font-size: 20px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.shadowBox {
  box-shadow: 0 0 5px #d0cece;
  padding: 15px 15px 0;
  border-radius: 10px;
}
.filterationBox {
  border: 1px solid #efefef;
  padding: 20px 20px 10px;
  margin-bottom: 20px;
  header {
    display: flex;
    margin-bottom: 10px;
    justify-content: space-between;
    font-weight: 500;
  }
  .toogleBox {
    display: none;
  }
  .filterBox {
    padding-left: 0;
    margin-bottom: 0;
    margin-top: 15px;
    li {
      font-size: 14px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      a {
        text-decoration: none;
        color: #000;
      }
    }
  }
  .detailList {
    padding-left: 0;
    margin-bottom: 10px;
    li {
      color: #8c8c8c;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 15px 0;
      .v-icon {
        margin-left: 10px;
        font-size: 20px;
      }
    }
  }
}
.v-input {
  margin-top: 0 !important;
}
a {
  text-decoration: none;
}
p {
  margin-bottom: 3px;
}
.orders {
  display: flex;
  padding-left: 0;
  list-style: none;
  flex-wrap: wrap;
  margin: 0 -15px;
  li {
    width: 50%;
    padding: 15px;
    .offerCard {
      box-shadow: 0 3px 5px #f2eeee;
      padding: 15px;
      display: flex;
      justify-content: flex-start;
      .image {
        width: 150px;
        height: 150px;
        background: #f4f4f4;
        img {
          object-fit: contain;
          width: 150px;
          height: 150px;
          border-radius: 10px;
        }
        margin-right: 10px;
      }
      .offerDescription {
        width: 75%;
        padding-left: 15px;
        .offerTitle {
          color: rgba(26, 26, 26, 1);
          font-weight: 600;
          font-size: 20px;
        }
        .price {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          p {
            font-size: 16px;
          }
        }
      }
    }
    .text-red {
      color: rgba(197, 46, 127, 1);
      font-weight: 700;
    }
    .text-yellow {
      color: #f9be27 !important;
      font-size: 18px;
    }
    .salePrice {
      position: relative;
      text-decoration: line-through;
      &::after {
        position: absolute;
        text-decoration: none;
      }
    }
  }
}

.pagination {
  list-style: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .v-icon {
    font-size: 18px;
    height: 30px;
    width: 30px;
    display: flex;
  }
}
</style>